import { Button, Drawer, Table } from 'antd';
import { useEffect, useState } from 'react';

const columns = [
	{
		title: 'Error Sr. No',
		dataIndex: 'sr',
	},
	{
		title: 'Error Message',
		dataIndex: 'errorMessage',
	},
];
const ErrorLogComponent = (props) => {
	const { visible, onClose } = props;
	const [tableData, setTableData] = useState([]);

	const closeModal = () => {
		setTableData([]);
		onClose();
	};

	useEffect(() => {
		if (visible) {
			let tempArray = [];
			const errorArray = visible.split(' |#%$| ');
			errorArray.map((data) => {
				let tempObj = {
					sr: data.split('-')[0],
					errorMessage: data.split('-')[1],
				};
				tempArray.push(tempObj);
			});
			setTableData(tempArray);
		}
	}, [visible]);
	return (
		<Drawer
			title="File Error Log"
			onClose={closeModal}
			open={visible}
			destroyOnClose
			width={'45%'}
			footer={
				<Button key={2} onClick={closeModal}>
					Cancel
				</Button>
			}
		>
			<Table
				bordered
				columns={columns}
				dataSource={tableData}
				pagination={false}
			/>
		</Drawer>
	);
};
export default ErrorLogComponent;
